module.exports = __webpack_public_path__ + "img/Radio oak.6375c0ac.jpg";